import { token } from '@cp/shared/di';
import { IResolver } from '@cp/shared/resolver';
import { AdminRouteResource } from '../model';

export const ADMIN_ROUTE_RESOLVER = token<IResolver<AdminRouteResource>>('ADMIN_ROUTE_RESOLVER');
